/* ═══════════════════════════════════════════════════════════════════
   GateExtensionV39 — modal GATE VERSI + AMARAN EXTENSION BERGANDA, rupa v3.9
   (arahan user 2026-09-27: "patutnya guna design baru kita").

   Monokrom, token --s-* (tema gelap jalan), tiada gradien/emoji — corak SAMA
   modal "Allow user scripts" dalam WorkspaceView (mod 'userscript').
   ⭐ PARITI dengan modal lama (rupa lama kekal dalam WorkspaceView untuk
      !uiV39): tajuk/sub · lencana versi · badan · notis berganda · 4 langkah ·
      notis "masih versi lama" · Muat Turun · Saya Sudah Kemas Kini / Tutup ·
      mod 'duplicate' (3 sebab + 3 langkah + Faham). Kunci kamus SAMA.
   ⛔ RUPA SAHAJA — semakan versi (probeExtensionVersionSettled) kekal dalam
      WorkspaceView dan dihantar sebagai onSemak. Jangan pindah logik ke sini.
   ═══════════════════════════════════════════════════════════════════ */

const kotak = { background: 'var(--s-card)', border: '1px solid var(--s-line)', borderRadius: 12, padding: 12 };
const notis = { background: 'var(--s-fill)', borderRadius: 12, padding: 12 };
const teksKecil = { fontSize: 11.5, color: 'var(--s-ink-2)', margin: 0, lineHeight: 1.6 };

function Senarai({ tajuk, baris }) {
    return (
        <div style={kotak}>
            {tajuk ? <p style={{ fontSize: 11, fontWeight: 700, color: 'var(--s-ink)', margin: '0 0 6px' }}>{tajuk}</p> : null}
            <ol style={{ ...teksKecil, fontSize: 11.5, paddingLeft: 16, listStyle: 'decimal' }}>
                {baris.map((b, i) => <li key={i}>{b}</li>)}
            </ol>
        </div>
    );
}

export default function GateExtensionV39({
    t, T,
    mod,                 // 'duplicate' | lain-lain = gate versi
    bilExtension = 2,    // mod duplicate
    versiDiperlukan = '',
    adaBerganda = false, // gate versi: extension lama masih terpasang serentak
    paksa = false,       // gate versi: tiada butang Tutup
    semakan = null,      // null | 'checking' | 'still-old'
    onSemak,             // butang "Saya Sudah Kemas Kini"
    onTutup,
}) {
    const berganda = mod === 'duplicate';
    const butangUtama = {
        width: '100%', padding: '12px 16px', borderRadius: 12, background: 'var(--s-primary)', color: 'var(--s-primary-ink)',
        border: 0, fontWeight: 700, fontSize: 13.5, cursor: 'pointer', display: 'flex', alignItems: 'center',
        justifyContent: 'center', gap: 8, textDecoration: 'none',
    };
    const butangKedua = {
        width: '100%', padding: '10px 16px', borderRadius: 12, background: 'transparent', color: 'var(--s-ink-2)',
        border: '1px solid var(--s-line)', fontWeight: 600, fontSize: 12.5, cursor: 'pointer', display: 'flex',
        alignItems: 'center', justifyContent: 'center', gap: 6,
    };
    const ikon = (nama, saiz = 18) => <span className="material-symbols-outlined" style={{ fontSize: saiz }}>{nama}</span>;

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,.62)', display: 'grid', placeItems: 'center', padding: 16 }}>
            <div style={{ width: '100%', maxWidth: 420, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto', background: 'var(--s-panel)', border: '1px solid var(--s-line)', borderRadius: 'var(--s-r-lg)', boxShadow: 'var(--s-shadow-modal)' }}>
                {/* Kepala monokrom — ikon dalam petak --s-fill, bukan gradien */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px', borderBottom: '1px solid var(--s-line)' }}>
                    <div style={{ width: 38, height: 38, borderRadius: 12, background: 'var(--s-fill)', display: 'grid', placeItems: 'center', flex: 'none', color: 'var(--s-ink)' }}>
                        {ikon(berganda ? 'extension_off' : 'system_update', 20)}
                    </div>
                    <div>
                        <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--s-ink)', margin: 0 }}>
                            {berganda ? T('ws.vergate.dupTitle', 'Extension Lama Masih Terpasang') : T('ws.vergate.title', 'Kemas Kini Extension Diperlukan')}
                        </h3>
                        <p style={{ fontSize: 11, color: 'var(--s-ink-2)', margin: 0 }}>
                            {berganda ? T('ws.vergate.dupSub', 'Sila buang versi lama daripada browser') : T('ws.vergate.sub', 'Versi terkini diperlukan untuk meneruskan')}
                        </p>
                    </div>
                </div>

                {berganda ? (
                    <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <p style={{ fontSize: 13.5, color: 'var(--s-ink-2)', margin: 0, lineHeight: 1.6 }}>
                            {t('ws.vergate.dupBody', { n: bilExtension })}
                        </p>
                        <div style={notis}>
                            <p style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--s-ink)', margin: '0 0 4px' }}>{T('ws.vergate.dupWhyTitle', 'Kenapa ia perlu dibuang?')}</p>
                            <ul style={{ ...teksKecil, paddingLeft: 16, listStyle: 'disc' }}>
                                <li>{t('ws.vergate.dupWhy1')}</li>
                                <li>{t('ws.vergate.dupWhy2')}</li>
                                <li>{t('ws.vergate.dupWhy3')}</li>
                            </ul>
                        </div>
                        <Senarai baris={[t('ws.vergate.dupStep1'), t('ws.vergate.dupStep2'), T('ws.vergate.dupStep3', 'Pastikan tinggal satu sahaja, kemudian refresh tab ini')]} />
                        <button onClick={onTutup} style={{ ...butangUtama, marginTop: 4 }}>
                            {T('ws.vergate.dupOk', 'Faham')}
                        </button>
                    </div>
                ) : (
                    <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {/* Lencana versi — monokrom: lama = garis putus-putus, diperlukan = isi */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: 11, fontWeight: 600, padding: '4px 10px', borderRadius: 999, border: '1px dashed var(--s-line)', color: 'var(--s-ink-2)' }}>
                                {T('ws.vergate.yourVersionOld', 'Versi anda: lama')}
                            </span>
                            <span style={{ color: 'var(--s-ink-3)', display: 'inline-flex' }}>{ikon('arrow_forward', 16)}</span>
                            <span style={{ fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 999, background: 'var(--s-select)', color: 'var(--s-select-ink)' }}>
                                {T('ws.vergate.requiredVersion', `Diperlukan: v${versiDiperlukan}`, { versi: versiDiperlukan })}
                            </span>
                        </div>
                        <p style={{ fontSize: 13.5, color: 'var(--s-ink-2)', margin: 0, lineHeight: 1.6, textAlign: 'center' }}>
                            {T('ws.vergate.body', 'Anda masih menggunakan versi lama extension SESAAT. Sila kemas kini untuk meneruskan penggunaan.')}
                        </p>

                        {/* Extension lama masih terpasang serentak — itulah puncanya. */}
                        {adaBerganda && (
                            <div style={notis}><p style={teksKecil}>{t('ws.vergate.duplicateNotice')}</p></div>
                        )}

                        <Senarai baris={[
                            T('ws.vergate.step1', 'Muat turun fail ZIP di bawah'),
                            t('ws.vergate.step2'),
                            T('ws.vergate.step3', 'Pasang extension baharu (panduan penuh di Dashboard, Step 1)'),
                            // Petikan mesti sepadan dengan label butang `ws.vergate.iHaveUpdated`.
                            t('ws.vergate.step4'),
                        ]} />

                        {semakan === 'still-old' && (
                            <div style={{ background: 'var(--s-stop-soft)', borderRadius: 12, padding: 12 }}>
                                <p style={{ ...teksKecil, color: 'var(--s-stop)' }}>{t('ws.vergate.stillOld')}</p>
                            </div>
                        )}

                        <a href="/SESAAT-EXTENSION.zip" download="SESAAT-EXTENSION.zip" style={{ ...butangUtama, marginTop: 4 }}>
                            {ikon('download')}
                            {T('ws.vergate.download', 'Muat Turun Versi Terkini')}
                        </a>
                        {paksa ? (
                            <button onClick={onSemak} disabled={semakan === 'checking'} style={{ ...butangKedua, opacity: semakan === 'checking' ? 0.55 : 1 }}>
                                {ikon(semakan === 'checking' ? 'progress_activity' : 'refresh', 16)}
                                {semakan === 'checking' ? T('ws.vergate.checking', 'Menyemak…') : T('ws.vergate.iHaveUpdated', 'Saya Sudah Kemas Kini')}
                            </button>
                        ) : (
                            <button onClick={onTutup} style={{ ...butangKedua, border: 0 }}>
                                {T('ws.vergate.close', 'Tutup')}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
